import { VOneUrl } from "../url";

/*
The Url endpoints for the License API.

Attributes:
    base: The base url.
    create: The url for creating a License.
    login: The url for logging in a License.
 */
export class LicensesUrl extends VOneUrl {
    public base: string;
    public assign: string;
    public unassign: string;

    constructor() {
        super();
        this.base = this.defineRoot() + "api/v1/user";
        this.assign = this.base + "/add/license";
        this.unassign = this.base + "/remove/license";
    }
}
